import { UserProfile } from "./pages/UserProfile"

const settings = {
  routes: [{ path: "/user-profile", component: UserProfile }],
}

export default settings
